module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2b0d62e3a1bea98cc8b226ccee65e6a2.png";